var map = {
	"./asp.gif": 1260,
	"./aspx.gif": 1261,
	"./avi.gif": 1262,
	"./bmp.gif": 1263,
	"./cs.gif": 1264,
	"./dll.gif": 1265,
	"./doc.gif": 1266,
	"./docx.gif": 1267,
	"./dwg.gif": 1268,
	"./excel.gif": 1269,
	"./gif.gif": 1270,
	"./htm.gif": 1271,
	"./jianchu.png": 570,
	"./jpe.gif": 1272,
	"./jpeg.gif": 1273,
	"./jpg.gif": 1274,
	"./na.gif": 1275,
	"./page.gif": 1276,
	"./pdd.gif": 1277,
	"./pdf.gif": 1278,
	"./pic.gif": 1279,
	"./png.gif": 1280,
	"./ppt.gif": 1281,
	"./pptx.gif": 1282,
	"./rar.gif": 1283,
	"./tishi.png": 387,
	"./txt.gif": 1284,
	"./wenjianjia.png": 292,
	"./xls.gif": 1285,
	"./xlsx.gif": 1286,
	"./上锁.png": 571,
	"./个人文档.png": 572,
	"./公共文档.png": 573,
	"./回收站.png": 574,
	"./收藏夹.png": 575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;